var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-content',{staticClass:"e-registration-register-success-view"},[_c('b-card',{staticClass:"e-registration-register-success-view__content"},[_c('h5',[_vm._v(_vm._s(_vm.$t("title")))]),_c('p',[_vm._v(_vm._s(_vm.$t("desc")))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }